import { Tabs, Tab } from '../../components';
import { PERMISSIONS } from '../../shared/constants/permissions';
import { useTabPersistence } from '../../shared';
import { usePermissionAllowed } from '../../hooks/usePermissionAllowed';
import { DashboardTab } from './components/Dashboard';
import { CampaignTab } from './components/Campaign';
import { WidgetTab } from './components/Widget';

type TabsEnum = 'client' | 'campaign' | 'widget';

const AnalyticsPageWrapper = () => {
  const hasDashboardAnalytics = usePermissionAllowed([
    PERMISSIONS.VIEW_DASHBOARD_ANALYTICS,
  ]);
  const hasWidgetAnalytics = usePermissionAllowed([
    PERMISSIONS.VIEW_WIDGET_ANALYTICS,
  ]);
  const isSuperAdmin = usePermissionAllowed([PERMISSIONS.SUPER_ADMIN]);

  const availableTabs: TabsEnum[] = [];
  if (hasDashboardAnalytics) {
    availableTabs.push('client');
  }
  if (isSuperAdmin) {
    availableTabs.push('campaign');
  }
  if (hasWidgetAnalytics) {
    availableTabs.push('widget');
  }

  const tabPersistenceConfig = {
    paramName: 'tab',
    defaultTab: availableTabs[0] as TabsEnum,
    updateHistory: true,
  };

  const { selectedTab, setSelectedTab, isReady } = useTabPersistence(
    tabPersistenceConfig,
    availableTabs
  );

  if (availableTabs.length === 0) {
    return <div>No access</div>;
  }

  if (!isReady) {
    return <div>Loading...</div>;
  }

  if (availableTabs.length === 1) {
    const singleTab = availableTabs[0];
    if (singleTab === 'client') {
      return <DashboardTab />;
    }
    if (singleTab === 'widget') {
      return <WidgetTab />;
    }
    if (singleTab === 'campaign') {
      return <CampaignTab />;
    }
  }

  if (!isReady) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Tabs<TabsEnum>
        tabs={[
          {
            name: 'client',
            label: 'Client',
            action: PERMISSIONS.VIEW_DASHBOARD_ANALYTICS,
          },
          {
            name: 'campaign',
            label: 'Campaign',
            action: PERMISSIONS.SUPER_ADMIN,
          },
          {
            name: 'widget',
            label: 'Widget',
            action: PERMISSIONS.VIEW_WIDGET_ANALYTICS,
          },
        ]}
        activeTab={selectedTab}
        onChange={setSelectedTab}
        contentClassName="mt-md"
      >
        <Tab name="client">
          <DashboardTab />
        </Tab>
        <Tab name="campaign">
          <CampaignTab />
        </Tab>
        <Tab name="widget">
          <WidgetTab />
        </Tab>
      </Tabs>
    </>
  );
};

export default AnalyticsPageWrapper;
